import { AsyncMultiComboBox, type ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import { getCustomerGroups, type GetCustomerGroupsParams } from '../../api/clients/company.api';
import { queries } from '../../api/queryKeys/queries';
import type { AsyncMultiSelectProps } from '../AsyncSelectProps';

interface CustomerGroupMultiSelectProps extends AsyncMultiSelectProps {
    onChange: (customerGroupIds: string[]) => void;
    value: string[];
}

const loadCustomerGroups = async (params: GetCustomerGroupsParams): Promise<ComboBoxOption[]> => {
    const customerGroups = await getCustomerGroups(params);

    return customerGroups.map((customerGroup) => ({
        value: customerGroup.id,
        label: customerGroup.name,
    }));
};

export function CustomerGroupMultiSelect({ value, onChange, ...rest }: CustomerGroupMultiSelectProps) {
    return (
        <AsyncMultiComboBox
            {...rest}
            value={value}
            onChange={onChange}
            optionsQueryKey={(search) => queries.customerGroups.comboBoxOptions({ searchQuery: search }).queryKey}
            optionsQueryFn={(search) => loadCustomerGroups({ searchQuery: search })}
            selectedOptionsQueryKey={(values) => queries.customerGroups.comboBoxOptions({ ids: values }).queryKey}
            selectedOptionsQueryFn={(values) => loadCustomerGroups({ ids: values })}
        />
    );
}
